import React from 'react';
import { IconButton, Tooltip, Box } from '@mui/material';
import { Logout } from '@mui/icons-material';

interface LogoutButtonProps {
  onLogout: () => void;
  position?: 'fixed' | 'absolute' | 'relative';
  top?: number | string;
  right?: number | string;
  zIndex?: number;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({
  onLogout,
  position = 'fixed',
  top = 24,
  right = 24,
  zIndex = 1000,
}) => {
  return (
    <Box
      sx={{
        position,
        top,
        right,
        zIndex,
      }}
    >
      <Tooltip title="Sign out of your account">
        <IconButton
          onClick={onLogout}
          sx={{
            background: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(20px)',
            color: 'white',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            p: 1.5,
            '&:hover': {
              background: 'rgba(255, 255, 255, 0.2)',
              transform: 'scale(1.05)',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            },
            transition: 'all 0.3s ease',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          <Logout sx={{ fontSize: 24 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default LogoutButton;
